import { useTranslation } from "react-i18next";
import { Button } from "shared/components/ui/button";
import { EmailLogin } from "./EmailLogin";
import colorsStore from "shared/store/colorsStore";
import { AuthService } from "shared/services/AuthService";
import { MicrosoftIcon } from "shared/assets/svg/MicrosoftIcon";

export const LoginPage: React.FC = () => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const { t } = useTranslation();

  return (
    <div className="mx-4 grid h-full place-items-center">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="space-y-2 pb-4">
          <h1>{t("login.title")}</h1>
          <h3 className="font-medium dark:text-gray-500">
            {t("login.desc")}
            <a
              href="https://get.streetbeat.com/api/demo-request"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="ml-1" style={{ color: colorsConfig.main }}>
                {t("signup.form")}
              </span>
            </a>
          </h3>
        </div>
        <div className="space-y-4">
          <LoginButton
            text={t("login.withMicrosoft")}
            icon={<MicrosoftIcon />}
            onClick={() => AuthService.signInWithMicrosoft()}
          />
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <span className="w-full border-t" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="text-muted-foreground bg-white px-2">
                {t("login.withEmail")}
              </span>
            </div>
          </div>
          <EmailLogin />
        </div>
      </div>
    </div>
  );
};

type LoginButtonProps = {
  text: string;
  icon: JSX.Element;
  onClick?: () => void;
};

const LoginButton: React.FC<LoginButtonProps> = ({
  text,
  icon,
  onClick,
}) => {
  return (
    <div className="w-full">
      <Button
        variant="login"
        className="w-full gap-4"
        onClick={() => onClick?.()}
      >
        {icon}
        {text}
      </Button>
    </div>
  );
};
